import { render } from "./PatientLayout.vue?vue&type=template&id=242f78ca"
import script from "./PatientLayout.vue?vue&type=script&lang=js"
export * from "./PatientLayout.vue?vue&type=script&lang=js"

import "./PatientLayout.vue?vue&type=style&index=0&id=242f78ca&lang=scss"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__